<template>
    <div>
        <div class="row">
            <div class="sm-12">
                <div class="title">
                    <h2>Totalização</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="sm-12">
                <Card>
                    <div class="row">
                        <div class="sm-12">
                            <p>
                                Saldo Anterior: <span v-raw :class="totalizacao.ValorAnterior < 0 ? 'text-red' : 'text-green'">{{ totalizacao.ValorAnterior | number_format }}</span>
                                <br />Débito: <span v-raw class="text-red">{{ -totalizacao.ValorDebito | number_format }} </span>
                                <br />Crédito: <span v-raw class="text-green">{{ totalizacao.ValorCredito | number_format }}</span>
                                <br />Saldo Atual: <span v-raw :class="totalizacao.ValorAtual < 0 ? 'text-red' : 'text-green'">{{ totalizacao.ValorAtual | number_format }}</span>
                                <br />
                            </p>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>
<script>
import Card from '../../../components/Card.vue';
export default {
    props: ["totalizacao"],
    components: {
        Card
    },
    filters: {
        number_format(value) {
            let sign = '';
            if (value < 0) {
                sign = '<b class="number-sign">-</b>'
            }
            let str = sign + new Intl.NumberFormat("pt-BR", {
                currencySign: 'accounting',
                //currencySign: 'standard',
                style: "decimal",
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Math.abs(value));

            return str;
        },
    },
};
</script>